import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=bfde1ed4&scoped=true"
import script from "./Show.vue?vue&type=script&lang=ts"
export * from "./Show.vue?vue&type=script&lang=ts"
import style0 from "./Show.vue?vue&type=style&index=0&id=bfde1ed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfde1ed4",
  null
  
)

export default component.exports